import getStore from '../store/store';
import showHideReportErrorForm from 'mini-report-error/lib/actions/showHideReportErrorForm';
import { FeedbackType } from '../store/schema/FeedbackFormInfo';
import { MiniWorkLoad } from 'mini-workload';
import { mutator } from 'satcheljs';

/**
 * Mutates the feedbackInfo in calendar store based on the input
 */
const showHideReportErrorFormMutator = mutator(showHideReportErrorForm, ({ source, show }) => {
    if (source === MiniWorkLoad.Calendar) {
        getStore().feedbackFormInfo = {
            isFeedbackFormVisible: show,
            feedbackType: show ? FeedbackType.Error : FeedbackType.None,
        };
    }
});

export default showHideReportErrorFormMutator;
